/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerLoanPricingDto } from './BorrowerLoanPricingDto';
import {
    BorrowerLoanPricingDtoFromJSON,
    BorrowerLoanPricingDtoFromJSONTyped,
    BorrowerLoanPricingDtoToJSON,
    BorrowerLoanPricingDtoToJSONTyped,
} from './BorrowerLoanPricingDto';

/**
 * 
 * @export
 * @interface BorrowerPricingDto
 */
export interface BorrowerPricingDto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerPricingDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerPricingDto
     */
    name: string;
    /**
     * 
     * @type {Array<BorrowerLoanPricingDto>}
     * @memberof BorrowerPricingDto
     */
    loans: Array<BorrowerLoanPricingDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BorrowerPricingDto
     */
    medicalDocuments?: Array<string>;
}

/**
 * Check if a given object implements the BorrowerPricingDto interface.
 */
export function instanceOfBorrowerPricingDto(value: object): value is BorrowerPricingDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('loans' in value) || value['loans'] === undefined) return false;
    return true;
}

export function BorrowerPricingDtoFromJSON(json: any): BorrowerPricingDto {
    return BorrowerPricingDtoFromJSONTyped(json, false);
}

export function BorrowerPricingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerPricingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'loans': ((json['loans'] as Array<any>).map(BorrowerLoanPricingDtoFromJSON)),
        'medicalDocuments': json['medicalDocuments'] == null ? undefined : json['medicalDocuments'],
    };
}

export function BorrowerPricingDtoToJSON(json: any): BorrowerPricingDto {
    return BorrowerPricingDtoToJSONTyped(json, false);
}

export function BorrowerPricingDtoToJSONTyped(value?: BorrowerPricingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'loans': ((value['loans'] as Array<any>).map(BorrowerLoanPricingDtoToJSON)),
        'medicalDocuments': value['medicalDocuments'],
    };
}

